import { WixThemeVariableNames } from './wix-theme-variable';
const colorKeys = ['color', 'Color'];
const fontKeys = ['font', 'Font'];
const upperFirst = value => value[0].toUpperCase() + value.slice(1);
const pascalCase = value => {
  const parts = value.split(/-|_/g);
  const capitalizedParts = parts.map(p => upperFirst(p));
  return capitalizedParts.join('');
};
const makePascalCaseMap = keys => Object.fromEntries(keys.map(key => [pascalCase(key), key]));
const allThemeVariables = Object.keys(WixThemeVariableNames);
const cssColorEntries = allThemeVariables.filter(key => colorKeys.some(a => key.includes(a)));
const cssFontEntries = allThemeVariables.filter(key => fontKeys.some(a => key.includes(a)));
export const CssColor = makePascalCaseMap(cssColorEntries);
export const CssFont = makePascalCaseMap(cssFontEntries);
export const CssVariable = makePascalCaseMap(allThemeVariables);
//# sourceMappingURL=by-value.js.map